import React, { useMemo } from 'react';
import { ThemeProvider, GlobalStyles } from '@mui/material';
import { createSeminargoTheme, seminargoColor, semColor } from '../theme';
import { bookingModeSelector } from '../helper/filter';
import { EBookingMode } from '../types';

interface DynamicThemeProviderProps {
  children: React.ReactNode;
}

/**
 * Theme provider that switches primary color based on booking mode.
 * Uses semColor for SEM mode, seminargoColor for EPILO mode.
 * Applies global link styles matching primary color.
 */
export const DynamicThemeProvider: React.FC<DynamicThemeProviderProps> = ({ children }) => {
  const bookingMode = bookingModeSelector();

  const primaryColor = useMemo(() => {
    return bookingMode === EBookingMode.SEM ? semColor : seminargoColor;
  }, [bookingMode]);

  const theme = useMemo(() => {
    return createSeminargoTheme(primaryColor);
  }, [primaryColor]);

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyles
        styles={{
          a: {
            color: primaryColor,
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline',
            },
          },
        }}
      />
      {children}
    </ThemeProvider>
  );
};
